import React from 'react';
import Header from '../Components/Header'
import InfoBodyMerchant from "../Components/InfoBodyMerchant";


const InfoVisa = () => {
    return (
        <div className='h-screen w-full'>
            <Header />
            <InfoBodyMerchant />
        </div>
    );
}

export default InfoVisa;